import { render, staticRenderFns } from "./com_data_checkbox.vue?vue&type=template&id=55a9702a&scoped=true&"
import script from "./com_data_checkbox.vue?vue&type=script&lang=js&"
export * from "./com_data_checkbox.vue?vue&type=script&lang=js&"
import style0 from "./com_data_checkbox.vue?vue&type=style&index=0&id=55a9702a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9702a",
  null
  
)

export default component.exports